import type { SVGProps } from "react";

export function Satellite(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="6" y="6" width="8" height="8" transform="rotate(45 10 10)" />
      <path d="M14 14l6 6" />
      <path d="M2 2l6 6" />
      <path d="M16 4l4-2" />
      <path d="M4 16l-2 4" />
    </svg>
  );
}
